import { Controller } from "@hotwired/stimulus"

// Renders a Cloudflare Turnstile widget. The sign-up form is injected into a
// <turbo-frame> after the page (and Turnstile's api.js) has loaded, so implicit
// auto-render won't pick it up — we render explicitly on connect instead, and
// poll briefly in case api.js is still loading.
export default class extends Controller {
  static values = { sitekey: String }

  connect() {
    this.#renderWhenReady()
  }

  disconnect() {
    if (this.pollId) clearInterval(this.pollId)
    if (this.widgetId && window.turnstile) {
      try { window.turnstile.remove(this.widgetId) } catch (_) { /* noop */ }
    }
  }

  #renderWhenReady() {
    if (window.turnstile) {
      this.widgetId = window.turnstile.render(this.element, { sitekey: this.sitekeyValue })
      return
    }
    this.pollId = setInterval(() => {
      if (window.turnstile) {
        clearInterval(this.pollId)
        this.pollId = null
        this.widgetId = window.turnstile.render(this.element, { sitekey: this.sitekeyValue })
      }
    }, 200)
  }
}
